import { DEFAULT_LAYOUT } from '@/constants';
export default [{
  path: '/requests',
  name: 'requests',
  meta: {
    modelName: 'requests',
    needGuard: true,
    modules: ['requests_tables'],
    layout: DEFAULT_LAYOUT
  },
  redirect: {
    name: 'table_requests'
  },
  component: function component() {
    return import('@/modules/requests/Requests.vue');
  },
  children: [{
    path: '/requests/tables_requests/',
    name: 'table_requests',
    meta: {
      modelName: 'table_requests',
      needGuard: true,
      modules: ['requests_tables'],
      layout: 'RequestTablesLayout'
    },
    component: function component() {
      return import('@/modules/requests/RequestManagement.vue');
    }
  }, {
    path: '/requests/request_cards',
    name: 'request_cards',
    meta: {
      modelName: 'orders',
      needGuard: true,
      modules: ['orders'],
      layout: 'RequestsLayout'
    },
    component: function component() {
      return import('@/modules/requests/requests/RequestCards.vue');
    }
  }, {
    path: '/requests/delivery',
    name: 'delivery',
    meta: {
      modelName: 'orders',
      needGuard: true,
      modules: ['orders'],
      layout: 'RequestsLayout'
    },
    component: function component() {
      return import('@/modules/requests/delivery/Delivery.vue');
    }
  }]
}];